export default "__VITE_ASSET__9a225e7d__"